var Scrollbar, scrollbar;
let Parallax = {
	top: 0,
	end: 0,
	show: 0,
	h: 0,
	speed: 0
}
let ps = [];
let Title = {
	top: 0,
	btm: 0
}
let stopPos = [];
//他ページと同様にshopを取得しようとしてるので消す
var special = {
	topD: 0,
	scrollTop: 0,
	name: "",
	init: function(){
		isSpecialPage = true;
		special.name = $("main").attr("data-page");
		special.resize();
		if (window.matchMedia('all and (min-width : 864px)').matches) {
			isSmallScreen = false;
		} else if(window.matchMedia('all and (min-width : 0px)').matches) {
			isSmallScreen = true;
		}
		if( special.name === "honzo"){
			weather.init();
			special.initScroll();
		}else if( special.name === "sav" ){
			special.initScroll();
			articleSpots = [];
			area.loadShop();
		}
		let touchArea = document.getElementsByTagName("body");
		// touchstartイベント
		touchArea[0].addEventListener("touchstart", function(e) {
			if( !$html.classList.contains("touching") ){
				$html.classList.add("touching");
			}
		}, false);
	
		// touchendイベント
		touchArea[0].addEventListener("touchend", function(e) {
			if( $html.classList.contains("touching") ){
				$html.classList.remove("touching");
			}
		}, false);
		
	},
	initScroll: function(){
		if(isSP){
				
		}else{
			if(!isIE11){
				scrollbar = Scrollbar.init( document.querySelector('#wrapper') );
			}
		}
		let topD, btmD;
		if(isSP || isIPad || isIE11){
			$(document).off("scroll touchmove").on("scroll touchmove", function(){
				spScroll();
			});
		}else{
			if(isSmallScreen && isSP){
				$(document).off("scroll touchmove").on("scroll touchmove", function(){
					spScroll();
				});
			}else{
				
				scrollbar.removeListener(null);
				scrollbar.addListener((listener) =>{
					clearTimeout(scrollTimeId);
					
					special.topD 		= listener.offset.y;
					special.scrollTop 	= listener.offset.y;
					topD = listener.offset.y;
					btmD = topD + window.innerHeight;
					special.scroll(topD, btmD);
					if( $html.classList.contains("show_reserve_nav") ){
						$html.classList.remove("show_reserve_nav");
					}
					scrollTimeId = setTimeout( function () {
						common.beforeTopD = special.topD;
						if( !$html.classList.contains("show_reserve_nav") ){
							$html.classList.add("show_reserve_nav");
						}
					}, 200 ) ;
					
					let diff = special.topD - common.beforeTopD;
					if(diff < -200){
						if( !$html.classList.contains("up") ){
							$html.classList.add("up");
							$html.classList.remove("down");
						}
					}else{
						if( !$html.classList.contains("down") ){
							$html.classList.remove("up");
							$html.classList.add("down");
						}
					}
				});
			}
		}
		function spScroll(){
			topD = $(document).scrollTop();
			special.scrollTop = topD;
			btmD = topD + window.innerHeight;
			special.scroll(topD, btmD);
		}
	},
	resize: function(){
		ps = [];
		$(".p").each(function(i){
			let _p = object(Parallax);
			if(!isSP && !isIPad && !isIE11 && !isEdge){
				_p.top 	= Math.floor( $(this).offset().top ) + special.scrollTop;
			}else{
				_p.top 	= Math.floor( $(this).offset().top );
			}
			let h = window.innerHeight + ":" +  $(".dmy").height();
			//$("header h1").html(h);
			_p.end = _p.top + $(".dmy").height();
			_p.h = $(this).outerHeight();
			_p.speed = $(this).attr("data-y");
			if(special.name === "sav"){
				if(isSmallScreen){
					_p.speed = _p.speed*.8;
				}
			}
			ps.push(_p);
		});
		
		/*
		stopPos = [];
		$(".fixed_nav").each(function(i){
			$(this).css({
				"top": $(".block_introduce").eq(i).find(".title_pos").offset().top + "px",
				"height": window.innerHeight + "px"
			});
		});
		$(".fixed_nav").each(function(i){
			let _s = object(Title);
			_s.top = $(this).offset().top;
			_s.btm = _s.top + $(".block_introduce").eq(i).outerHeight();
			stopPos.push(_s);
		});
		*/
		if(isSP){
			let topD = $(document).scrollTop();
			special.scrollTop = topD;
			let btmD = topD + window.innerHeight;
			special.scroll(topD, btmD);
		}
		//console.log(stopPos);
	},
	scrollToPos: function(){
		var $page 	= $("html,body"),
		ease 	= "easeInOutCubic";
	
		if( $(".scroll-content").length > 0 ){
			scrollbar.scrollTo(0, posY, duration,{});
		}else{
			$page.animate({
				scrollTop : posY + "px"
			},{
				"duration" 	: duration,
				"easing" 	: ease
			});
		}
	},
	scroll: function(topD, btmD){
		common.scrollCommon(topD, btmD);
		//console.log(topD, btmD);
		if(topD >= window.innerHeight){
			if( !$html.classList.contains("show_pagetop_special") ){
				$html.classList.add("show_pagetop_special");
			}
			if(btmD >= $("footer").offset().top){
				if( $html.classList.contains("show_pagetop_special") ){
					$html.classList.remove("show_pagetop_special");
				}
			}
		}else{
			if( $html.classList.contains("show_pagetop_special") ){
				$html.classList.remove("show_pagetop_special");
			}
		}
		let alen = animations.length;
		console.log(animations)
		for(var a = 0; a < alen; a++){
			if(a === alen - 1){
				if(btmD >= animations[a].show){
					activeAnimate(a);
				}
			}else{
				if(btmD >= animations[a].show){
					activeAnimate(a);
				}
			}
		}
		function activeAnimate(a){
			let $blk = $(".a").eq(a);
			if(!$blk.hasClass("animate")){
				$blk.addClass("animate");
				setTimeout(function(){
					$blk.addClass("animated");
				},600);
			}
		}
		
		//parallax
		let base = 30;
		if(special.name === "honzo"){
			if(isSmallScreen){
				base = 20;
			}else{
				base = 15;
			}
		}
		
		for( let p = 0; p < ps.length; p++){
			if( (btmD + 100) >= ps[p].top){
				let $p = $(".p").eq(p);
				
				if(isSP){
					//base = base/3;
				}
				let totalDistance = base*ps[p].speed;
				let total = (ps[p].end - ps[p].top);
				let y = (totalDistance / total) * (ps[p].top - topD)*2;
				if(p === 1 && special.name === "honzo"){
					if(y > 0){
						y = 0;
					}
				}
				//console.log(p,y);
				$p.css({
					"transform": `translate3d(0, ${y}px, 0)`
				});
			}
		}
		/*
		for(var sp = 0; sp < stopPos.length; sp++){
			if( topD + $("header").height() >= stopPos[sp].top) {
				let $blk = $(".fixed_nav").eq(sp);
				if( !$blk.hasClass("fix") ){
					$blk.addClass("fix");
				}
			}else{
				let $blk = $(".fixed_nav").eq(sp);
				if( $blk.hasClass("fix") ){
					$blk.removeClass("fix");
				}
			}
		}
		*/
		function activeAnimate(a){
			let $blk = $(".a").eq(a);
			if(!$blk.hasClass("animate")){
				$blk.addClass("animate");
				setTimeout(function(){
					$blk.addClass("animated");
				},600);
			}
		}
	}
}